export default __webpack_public_path__ + "static/media/envelop.c54daa76.svg";